
import { useParams, useNavigate } from "react-router-dom";
import { AuthCheck } from "@/components/auth/AuthCheck";
import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { ProgramViewerLayout } from "@/components/programs/viewer/ProgramViewerLayout";
import { ProgramDetailsContent } from "@/components/programs/viewer/ProgramDetailsContent";
import { useProgramData } from "@/hooks/useProgramData";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as SonnerToaster } from "sonner";

export default function ProgramViewer() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Use the custom hook to fetch program data
  const { programName, programOverview, programData, loading } = useProgramData(id, navigate);
  
  const handleBack = () => {
    navigate("/programs");
  };
  
  const BackButton = (
    <Button 
      variant="ghost" 
      className="text-white hover:bg-white/10"
      onClick={handleBack}
    >
      <ArrowLeft className="h-5 w-5 mr-2" />
      Back
    </Button>
  );
  
  return (
    <AuthCheck>
      <BackgroundGradientAnimation
        containerClassName="min-h-screen"
        gradientBackgroundStart="rgb(108, 0, 162)"
        gradientBackgroundEnd="rgb(0, 17, 82)"
        firstColor="18, 113, 255"
        secondColor="221, 74, 255"
        thirdColor="100, 220, 255"
        fourthColor="200, 50, 50"
        fifthColor="180, 180, 50"
        pointerColor="140, 100, 255"
      >
        <ProgramViewerLayout 
          programName={programName}
          overview={programOverview}
          loading={loading}
          backButton={BackButton}
        >
          <ProgramDetailsContent 
            programData={programData}
            loading={loading}
            programId={id}
          />
        </ProgramViewerLayout>
        
        {/* Add both toaster providers to ensure all notifications work */}
        <Toaster />
        <SonnerToaster position="bottom-right" />
      </BackgroundGradientAnimation>
    </AuthCheck>
  );
}
